import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';

function onTaskCommentDeleted(event) {
  const tasksToUpdateMap = {};
  let ids = [];

  if (event.data?.ids.length) {
    ids = event.data.ids;
  } else if (event.data?.taskIds.length) {
    event.data.taskIds.forEach(tid => {
      const taskData = globalStore.getters['tasksModel/getTask'](tid);

      if (taskData && taskData.comments?.length) {
        ids.push(...taskData.comments?.map(comment => comment.id));
      }
    });
  }

  ids.forEach(commentId => {
    const storeComment = globalStore.getters['comments/getCommentById'](commentId);
    const taskData = globalStore.getters['tasksModel/getTaskByGanttId'](storeComment.projectId, storeComment.taskId);

    if (!storeComment || !taskData) {
      return;
    }

    const payload = {
      projectId: storeComment.projectId,
      commentId,
    };

    globalStore.commit('comments/removeComment', { ...payload, fromGantt: false }, { root: true });
    globalStore.commit('comments/removeCommentAction', { commentId, fromGantt: false }, { root: true });

    const hasComments = tasksToUpdateMap[storeComment.taskId] ? tasksToUpdateMap[storeComment.taskId].hasComments - 1 : +taskData.hasComments - 1;

    tasksToUpdateMap[storeComment.taskId] = {
      id: +storeComment.taskId,
      gantt_id: +taskData.gantt_id,
      hasComments,
      newComments: hasComments ? taskData.newComments : 0,
    };
  });

  if (!_.isEmpty(tasksToUpdateMap)) {
    globalStore.commit('tasksModel/updateTasks', { tasks: Object.values(tasksToUpdateMap), fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: [...event.data.ids],
  });
}

export default onTaskCommentDeleted;
